<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="DED"><span class="ePub-I">To everybody who told me I was wasting my teenage years by drinking, going to punk shows, and reading comic books: Thank you for being so hilariously wrong.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5e73da43